import { NotificationType } from '@components/Notification/Notification';

/**
 * Novu templates relatedEntities into the payload as a JSON-ish string with single quotes, so a
 * malformed value is always possible. Throwing here would escape into the SDK's event emitter on
 * every incoming notification, so an unreadable value degrades to no related entities instead.
 */
export const parseRelatedEntities = (
  relatedEntities: unknown
): NotificationType['relatedEntities'] => {
  if (Array.isArray(relatedEntities)) return relatedEntities;
  if (typeof relatedEntities !== 'string' || !relatedEntities) return [];

  try {
    const parsed = JSON.parse(
      relatedEntities.replace(/^"|"$/g, '').replace(/'/g, '"') || '[]'
    );
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    console.error('Unparseable notification relatedEntities:', relatedEntities);
    return [];
  }
};
